import type { FC } from 'react';
import { Labs } from '@/components/labs/index.tsx';

export const LabsPage: FC = () => <Labs />;
